import { VISA_TYPES } from "../mock";

// Visa categories a partner actually handles: the profile's own list, else derived from its type and routes. Drives the request form and the fit bars.
const RX = { tourist: /tourist|visit|group|schengen|type c|b-2|evisa/i, business: /business|b-1|conference/i, student: /stud|500|f-1|cas|study permit|student pass/i, work: /work|skilled|employ|482|h-1b|sponsor|blue card|employment pass|lmia/i, family: /family|partner|spouse|dependant/i, investor: /golden|invest|startup/i, pr: /express|189|190|settle|residen|green card|ilr/i, citizenship: /citizen|natural/i };
const TYPE_CATS = { "Travel agency": ["tourist", "business"], "Study consultancy": ["student"], "Study abroad consultancy": ["student"], "Immigration agency": ["work", "family", "pr", "citizenship"], "Immigration law firm": ["work", "family", "pr", "citizenship"], Employer: ["work"] };

export function partnerCategories(p) {
  if (p?.categories?.length) return p.categories;
  const out = new Set(TYPE_CATS[p?.type] || []);
  (p?.routes || []).forEach((r) => Object.entries(RX).forEach(([cat, rx]) => { if (rx.test(r)) out.add(cat); }));
  return [...out];
}

export const partnerVisaTypes = (p) => { const cats = partnerCategories(p); const list = VISA_TYPES.filter((v) => cats.includes(v.id)); return list.length ? list : VISA_TYPES; };

// Real-data helpers: rating only exists once a verified review exists; approvals only once a case has been decided.
export const hasRating = (p) => (p?.reviews || 0) > 0 && (p?.rating || 0) > 0;
export const hasOutcomes = (p) => (p?.decided || 0) > 0;
export const isNewPartner = (p) => !hasRating(p) && !hasOutcomes(p);
